export const resumeText = (text: string) => {
  if (text.length <= 15) return text;

  const start = text.slice(0, 5);
  const end = text
    .split("")
    .reverse()
    .filter((ch) => !start.includes(ch))
    .reverse()
    .join("");

  return `${start}...${end.length < 7 ? end : end.slice(-5)}`;
};
